import React, { useEffect, useState } from 'react';
import supabase from '../supabase/supabase';
import CrmDashboard from './CrmDashboard';
import CrmLogin from './CrmLogin';
import './crm.css';

export default function CrmApp() {
  const [session, setSession] = useState(null);
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function checkAccess(user) {
      if (!user) {
        if (active) { setAuthorized(false); setLoading(false); }
        return;
      }
      if (active) setLoading(true);
      const { data, error } = await supabase.from('crm_admins_20260912')
        .select('user_id').eq('user_id', user.id).maybeSingle();
      if (active) {
        setAuthorized(!error && Boolean(data));
        setLoading(false);
      }
    }
    supabase.auth.getSession().then(({ data }) => {
      if (active) {
        setSession(data.session);
        checkAccess(data.session?.user);
      }
    }).catch(() => { if (active) setLoading(false); });
    const { data: listener } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      if (active) {
        setSession(nextSession);
        checkAccess(nextSession?.user);
      }
    });
    return () => { active = false; listener.subscription.unsubscribe(); };
  }, []);

  if (loading) return <div className="crm-loading">Loading workspace…</div>;
  if (!session) return <CrmLogin />;
  if (!authorized) return (
    <div className="crm-auth"><div className="crm-auth-card"><span className="crm-kicker">ACCESS RESTRICTED</span><h1>Not authorized.</h1><p>This account has not been granted access to the customer CRM. Ask your Supabase project administrator to add your account.</p><button onClick={() => supabase.auth.signOut()}>Sign out</button></div></div>
  );
  return <CrmDashboard email={session.user.email} />;
}